import { DataBean } from "../DataBean";

export class UBLNotification extends DataBean {

    public async getUBLNotificationCatalog(idUBLInvoice: number, issueDate: any, type: number | undefined, code: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore",
            "com.advantage.shared.Report_getUBLNotificationCatalog_Number_java.util.Date_Number_String_Number_Number",
            [idUBLInvoice, issueDate, type, code, page, recordsPerPage]);
    }

    public async getUBLNotificationTypeConstants(arg: number | undefined): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLNotificationTypeConstants_Number", [arg]);
    }
    public async getRadianPurchaseEvents(arg: number | undefined): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getRadianPurchaseEvents_Number", [arg]);
    }
    public async sendRadianEvent(idEmployee: number, idUblInvoice: number, issueDate: any, code: string, props: any): Promise<any> {
        return this.getCustomService("CacheOptions",
            "com.advantage.shared.Report_sendRadianEvent_Number_Number_java.util.Date_String_java.util.Map",
            [idEmployee, idUblInvoice, issueDate, code, props]);
    }

}
